import { css } from '@emotion/css';

import { colors } from '@editor2/styles/colors';

export const figureElement = css`
	.select {
		width: 200px;
	}

	.mapPayloadBlock {
		display: flex;
		align-items: baseline;
		justify-content: space-between;
		margin-bottom: 5px;

		label {
			margin-bottom: 0;
		}
	}
`;
